import { api } from './api';
import { SavedAnalysis, SavedScenario } from '../types/user';
import { CalculatorParams, AnalysisResponse } from '../types/api';

export class SavedAnalysesService {
  async saveAnalysisWithScenarios(
    title: string,
    description: string,
    scenarios: SavedScenario[],
    timeHorizonYears: number
  ): Promise<SavedAnalysis> {
    try {
      return await api.saveAnalysisWithScenarios(title, description, scenarios, timeHorizonYears);
    } catch (error) {
      console.error('Failed to save analysis:', error);
      throw error;
    }
  }

  async saveAnalysis(
    title: string,
    description: string,
    parameters: CalculatorParams,
    analysisResult?: AnalysisResponse,
    scenarioTitles?: string[]
  ): Promise<SavedAnalysis> {
    try {
      return await api.saveAnalysis(title, description, parameters, analysisResult, scenarioTitles);
    } catch (error) {
      console.error('Failed to save analysis:', error);
      throw error;
    }
  }

  async getUserAnalyses(): Promise<SavedAnalysis[]> {
    try {
      const response = await api.getUserAnalyses();
      return response.analyses;
    } catch (error) {
      console.error('Failed to get user analyses:', error);
      throw error;
    }
  }

  async getAnalysis(analysisId: string): Promise<SavedAnalysis> {
    try {
      return await api.getAnalysis(analysisId);
    } catch (error) {
      console.error('Failed to get analysis:', error);
      throw error;
    }
  }

  async updateAnalysis(
    analysisId: string,
    title?: string,
    description?: string,
    parameters?: CalculatorParams,
    analysisResult?: AnalysisResponse
  ): Promise<SavedAnalysis> {
    try {
      return await api.updateAnalysis(analysisId, title, description, parameters, analysisResult);
    } catch (error) {
      console.error('Failed to update analysis:', error);
      throw error;
    }
  }

  async deleteAnalysis(analysisId: string): Promise<void> {
    try {
      await api.deleteAnalysis(analysisId);
    } catch (error) {
      console.error('Failed to delete analysis:', error);
      throw error;
    }
  }
}

export const savedAnalysesService = new SavedAnalysesService();
